<template>
    <div class="cellheaders">
        <div v-for="(date,index) in date_range" v-bind:key="index" :style="{width:cellwidth+'px', height: headerheight+'px'}"  :class="{todayHeader: date.today}" :id="date.today ? 'todayHeader': undefined" class="cellheader">{{date.value.format('MM/DD')}}</div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
  export default {
    name: 'CellHeaders',
    
    // components: {
    //   Row
    // },
    data: () => ({
    
    }),
    computed: {
        ...mapState(['cellwidth','headerheight','cellheight','moment']),
        ...mapGetters(['date_range'])
    },
    mounted(){
     
        let el = document.getElementById('todayHeader')
        if(el){
            document.getElementById('data_grid').scrollLeft = (this.moment().diff(this.date_range[0].value,'days')) * this.cellwidth
        }
    
    }
  }
</script>

<style>
.cellheaders{
display:flex;


}
.cellheader{
  background-color:#dfdfdf;
flex-shrink:0;
text-align:center;
font-size:.8em;
font-weight:bold;
border-right: solid 1px #cccccc;
border-top: solid 1px #cccccc;
box-sizing: border-box;
display:flex;
justify-content:center;
align-items:center;
border-bottom: solid 1px #cccccc;
}
</style>